export default "__VITE_ASSET__2d5c0a39__"